import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-snackbar-with-cp',
    templateUrl: './snackbar-with-cp.component.html',
    styleUrls: ['./snackbar-with-cp.component.scss']
})
export class SnackbarWithCpComponent {

    horizontalPosition: string = 'start';
    verticalPosition: string = 'bottom';

    constructor(private toastr: ToastrService) {}

    openSnackBar() {
        const horiz = (this.horizontalPosition === 'start' || this.horizontalPosition === 'left') ? 'left'
            : this.horizontalPosition === 'center' ? 'center' : 'right';
        const vert = (this.verticalPosition === 'top') ? 'top' : 'bottom';
        const positionClass = `toast-${vert}-${horiz}`; // e.g., toast-top-left
        this.toastr.success('Cannonball!!', '', { timeOut: 3000, positionClass });
    }

}